import { useState, useEffect, useRef } from "react";
import { makeStyles } from "@mui/styles";
import { useMutation, useQueryClient } from "react-query";
import AxiosT from "../../../setup/setup-axios-bearer";
import { Box, Button, TextField } from "@mui/material";
import { Add, Close } from "@material-ui/icons";
import { toast } from "react-toastify";

const useStyles = makeStyles({
  addBarcode: {
    padding: "0 24px",
    transform: "translateY(32px)",
    position: "relative",
    "& Button": {
      position: "absolute",
      top: "10px",
      left: "20px",
      padding: "6px",
      minWidth: "42px",
    },
    "& input": {
      height: "0.6em",
      padding: "22px 14px 22px 0",
      fontSize: "0.875rem",
      width: "100%",
      borderRadius: "21px",
      outline: "0",
      border: "1px solid rgb(113,113,113)",
      "&:focus": {
        boxShadow: "0 0 0 0.25rem rgb(13 ,110 ,253 , 25%)",
        borderColor: "#86b7fe",
      },
    },
  },
  clear: {
    position: "absolute",
    top: 16,
    left: 64,
    color: "#999",
    cursor: "pointer",
  },
});

const AddOut = ({ factorID }) => {
  const classes = useStyles();
  const [productCode, setProductCode] = useState();
  const [action, setAction] = useState("add-product");
  const queryClient = useQueryClient();

  const myRef = useRef();
  useEffect(() => {
    if (myRef && myRef.current) {
      const input = myRef.current;
      input.focus();
    }
  });

  const { data, isLoading, mutate } = useMutation(
    ({ action, product_code }) =>
      AxiosT.post(`/out-warehouse-with-factor/${factorID}`, {
        action,
        product_code,
      }),
    {
      onSuccess: (data) => {
        queryClient.resetQueries(["getSaleFactordetail"]);
      },
    }
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!productCode) {
      toast.info("لطفا کد محصول را وارد کنید");
    } else {
      mutate({
        action,
        product_code: productCode,
      });
    }
  };

  const handleClear = () => {
    setProductCode("");
  };

  return (
    <form onSubmit={handleSubmit}>
      <Box className={classes.addBarcode}>
        <input
          type="text"
          name="productCode"
          value={productCode}
          onChange={(e) => setProductCode(e.target.value)}
          ref={myRef}
          placeholder="کد کالا"
        />
        <Button variant="contained" startIcon={<Add />} type="submit"></Button>
        <Box className={classes.clear} onClick={handleClear}>
          <Close fontSize="small" />
        </Box>
      </Box>
    </form>
  );
};
export default AddOut;
